const DEFAULT_CHART_WIDTH = 600;
const PUBLICDATA = false;
const PUBLICATIONS_TAB_LABEL = "Publikationen";
const EVENTS_TAB_LABEL = "Biographien";

export {
    DEFAULT_CHART_WIDTH,
    PUBLICDATA,
    PUBLICATIONS_TAB_LABEL,
    EVENTS_TAB_LABEL
}
